import { PaymentProcessorConfigurationBase } from '../payment-processor-configuration-base';

export class UnibankPaymentProcessorConfiguration extends PaymentProcessorConfigurationBase {
  constructor(options?: Partial<UnibankPaymentProcessorConfiguration>) {
    super(options);

      // this.url = options?.url ?? '';


    if (options) {
      Object.assign(this, options);
    }
  }
}